import React from 'react'

const PreviousIcon = () => (
    <svg className="icon" width="22px" height="34px" viewBox="0 0 22 34" version="1.1" xmlns="http://www.w3.org/2000/svg" >
    <g id="Landing-page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.681780134" strokeLinecap="round" strokeLinejoin="round">
        <g id="Home-page" transform="translate(-99.000000, -383.000000)" stroke="#FFFFFF" strokeWidth="3">
            <polyline id="Path-2-Copy" transform="translate(110.000000, 399.571429) rotate(90.000000) translate(-110.000000, -399.571429) " points="95 391.200734 109.911662 408.142857 125 391"></polyline>
        </g>
    </g>
</svg>
)

export default PreviousIcon;